import { useState } from 'react';
import { G500LiteAuthInfoType, OffsegAuthInfoType } from '../../feature/type/AuthInfoType';
import { initG500LiteAuthInfo, initOffsegAuthInfo } from '../../../common/const/commonConst';

type InputType = {
	setIsReregistrationDialogStep1Opened: React.Dispatch<React.SetStateAction<boolean>>;
	setIsRegistrationError: (value: React.SetStateAction<boolean>) => void;
	setNeedsChangeInitPassword: (value: React.SetStateAction<boolean>) => void;
	setOffsegReregistrationAuthInfo: (value: React.SetStateAction<OffsegAuthInfoType>) => void;
	setG500LiteReregistrationAuthInfo: (value: React.SetStateAction<G500LiteAuthInfoType>) => void;
};

/**
 * G500Liteログイン情報再登録STEP2ダイアログの状態管理用カスタムフック
 */
export const useStateReregistrationStep2Dialog = (input: InputType) => {
	const { setIsReregistrationDialogStep1Opened, setIsRegistrationError, setNeedsChangeInitPassword, setOffsegReregistrationAuthInfo, setG500LiteReregistrationAuthInfo } = input;

	const [isReregistrationDialogStep2Opened, setIsReregistrationDialogStep2Opened] = useState(false); // G500Liteログイン情報再登録ダイアログStep2の開閉状態の管理

	// ログイン情報再登録ダイアログSTEP2を閉じる際の処理
	const onCloseReregistrationDialogStep2 = () => {
		setIsRegistrationError(false);
		setIsReregistrationDialogStep2Opened(false);
		setOffsegReregistrationAuthInfo(initOffsegAuthInfo);
		setG500LiteReregistrationAuthInfo(initG500LiteAuthInfo);
	};

	// ログイン情報再登録の戻るボタンを押下した際の処理
	const onClickReregistrationDialogStep2BackButton = () => {
		setIsRegistrationError(false);
		setNeedsChangeInitPassword(false);
		setOffsegReregistrationAuthInfo(initOffsegAuthInfo);
		setG500LiteReregistrationAuthInfo(initG500LiteAuthInfo);
		setIsReregistrationDialogStep2Opened(false);
		setIsReregistrationDialogStep1Opened(true);
	};

	return {
		isReregistrationDialogStep2Opened,
		setIsReregistrationDialogStep2Opened,
		onCloseReregistrationDialogStep2,
		onClickReregistrationDialogStep2BackButton,
	};
};
